// Corrigeert handmatig ingetypte hoeveelheden naar het dichtstbijzijnde veelvoud van de
// pu-waarde (custom.pu metafield). Werkt zowel op de PDP als in de cart drawer.
// 0 blijft altijd toegestaan (= regel verwijderen in de winkelmand).
document.addEventListener(
  'blur',
  (event) => {
    const input = event.target;
    if (!(input.matches && input.matches('.quantity__input'))) return;

    const pu = parseInt(input.dataset.pu, 10);
    if (!pu || pu <= 1) return;

    let value = parseInt(input.value, 10);
    if (isNaN(value) || value <= 0) {
      value = 0;
    } else {
      value = Math.round(value / pu) * pu;
      if (value < pu) value = pu;
    }

    if (String(value) !== input.value) {
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  },
  true
);